import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SidebarService {
  version = 'environment.version';
  currentDate = "utc().format('YYYY')";
  openState$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  private _WRT_URL$: ReplaySubject<string | null> = new ReplaySubject(1);
  private _CA_URL$: ReplaySubject<string | null> = new ReplaySubject(1);
  private _PULSE_URL$: ReplaySubject<string | null> = new ReplaySubject(1);
  private _appSwitcherVisible$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor() {
    this.getAppSwitcherVisible().subscribe(this._appSwitcherVisible$);
  }

  get WRT_URL$() {
    return this._WRT_URL$.asObservable();
  }

  get CA_URL$() {
    return this._CA_URL$.asObservable();
  }

  get PULSE_URL$() {
    return this._PULSE_URL$.asObservable();
  }

  get appSwitcherVisible$() {
    return this._appSwitcherVisible$.asObservable();
  }

  toggleState() {
    const newState = !this.openState$.value;
    this.openState$.next(newState);
  }

  private getAppSwitcherVisible() {
    return combineLatest([this._WRT_URL$, this._CA_URL$, this._PULSE_URL$]).pipe(
      map(([a, b]) => !!a || !!b)
    );
  }
}
